define('application',[
  "lib/angular/angular.min.js"
], function() {
  return angular.module("biddingWars", []);
});
